import { getCurrencySymbol, AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef, inject, signal, ViewChild } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ErrorMsgComponent } from '@fitness-force/errors';;
import { AngularQueryBuilderComponent, TaskCreateComponent } from '@fitness-force/shared';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';

import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';

import { OverlayModule } from 'primeng/overlay';
import { PopoverModule } from 'primeng/popover';
import { TableModule } from 'primeng/table';
import { TreeSelectModule } from 'primeng/treeselect';
import { CreateOpportunityComponent } from '@fitness-force/crm';
import { SendBulkEmailComponent } from '../send-bulk-email/send-bulk-email.component';
import { SendBulkSmsComponent } from '../send-bulk-sms/send-bulk-sms.component';
import { SendWhatsappComponent } from '../send-whatsapp/send-whatsapp.component';
import { ClientFilterComponent, ClientFilterOutput } from '../client-filter/client-filter.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { CITY_MASTER_STATE_LIST, COUNTRY_MASTER_STATE, COUNTRY_MASTER_STATE_LIST, STATE_MASTER_STATE_LIST, TENANTS_INFO } from '@fitness-force/state';
import type { AutomationActionPayload, AutomationActions, AutomationTableData, BlackoutConfig, CampaignActionsGroup, CampaignById, CampaignRequest, City, ClientFilter, Country, EmailActionPayload, NotificationToStaff, Params, PushNotificationActionPayload, Rule, ScheduleActionPayload, SmsActionPayload, SourceDataExtractionRules, State, TENANTSINTERFACE, TENANT_MODEL, TaskActionPayload, WhatsappActionPayload } from '@fitness-force/models';
import { AutomationEventType, CampaignSource, EmailSendType, OwnershipLevel, PushNotificationSendType, SMSSendType, SendNotificationTo, TaskCreateType, WhatsAppSendType } from '@fitness-force/enum';
import { CommonService, TimeconversionService, ToastMessageService,BlackoutConfigService, CampaignService } from '@fitness-force/api';
import { TreeNode } from 'primeng/api';
import { BreadcrumbComponent} from '@fitness-force/common/breadcrumb';
import { CONSTANTS_PREBUILD_CAMPAIGNS } from '@fitness-force/constants';
import { InputNumberModule } from 'primeng/inputnumber';
import { SendPushNotificationsComponent } from '../send-push-notifications/send-push-notification.component';
import {
  CommunicationCategoryService,
  isCommunicationCategoryActive,
} from '@fitness-force/communication-categories-lib';

@Component({
  selector: 'create-campaign',
  templateUrl: './create-campaign.component.html',
  styleUrls: ['./create-campaign.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ToggleSwitchModule,
    InputTextModule,
    DatePickerModule,
    SelectModule,
    EditorModule,
    ButtonModule,
    FileUploadModule,
    ErrorMsgComponent,
    OverlayModule,
    PopoverModule,
    CheckboxModule,
    TableModule,
    TreeSelectModule,
    CreateOpportunityComponent,
    SendBulkEmailComponent,
    SendBulkSmsComponent,
    SendWhatsappComponent,
    SendPushNotificationsComponent,
    TaskCreateComponent,
    ErrorMsgComponent,
    AngularQueryBuilderComponent,
    BreadcrumbComponent,
    InputNumberModule,
    ClientFilterComponent,
    TranslateModule,
    RouterModule,
    AsyncPipe,
    NgClass
]
})
export class CreateCampaignComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly store = inject(Store);
  private readonly timeService = inject(TimeconversionService);
  private readonly campaignsService = inject(CampaignService);
  private readonly blackoutService = inject(BlackoutConfigService);
  private readonly cd = inject(ChangeDetectorRef);
  private readonly translateService = inject(TranslateService);
  private readonly route = inject(ActivatedRoute);
  private readonly toastMessageService = inject(ToastMessageService);
  private readonly commonService = inject(CommonService);
  private readonly router = inject(Router);
  private readonly communicationCategoryService = inject(CommunicationCategoryService);

  @ViewChild(ClientFilterComponent) clientFilterComponent?: ClientFilterComponent;

  showActionGroup1: boolean = true;
  showClientFilter: boolean = true;
  showTable: boolean = true;
  actionsTableData:AutomationTableData[] = [];
  tenants: any[] = [];
  selectedTenant: { name: string } | undefined;
  tenantAccess: TENANT_MODEL[] = [];
  state$: State[] = [];
  city$: City[] = [];
  country$: Country[] = [];
  createCampaignForm: UntypedFormGroup = new UntypedFormGroup({});
  amountSpenderForm: UntypedFormGroup = new UntypedFormGroup({});
  Actions = [
    { text: 'SEND_EMAIL', key: 'sendemail' },
    { text: 'SEND_SMS', key: 'sendsms' },
    { text: 'SEND_WHATSAPP', key: 'sendwhatsapp'},
    { text: 'CREATE_TASK', key: 'createtask' },
    { text: 'SEND_PUSH_NOTIFICATION', key: 'sendpushnotifications' },
    //{ text: 'CREATE_OPPORTUNITY', key: 'createopportunity'}
  ];
  values: string[] = ['Mr.', 'Mrs.'];
  showCreateOpportunityPopup: boolean = false;
  showTaskCreate: boolean = false;
  showBulkEmailPopup: boolean = false;
  showBulkSmsPopup: boolean = false;
  showBulkWhatsAppPopup: boolean = false;
  showPushNotificationsPopup: boolean = false;
  EmailSendType: EmailSendType = EmailSendType.Campaign;
  SMSSendType: SMSSendType = SMSSendType.Campaign;
  WhatsAppSendType: WhatsAppSendType = WhatsAppSendType.Campaign;
  PushNotificationsSendType: PushNotificationSendType = PushNotificationSendType.Campaign;
  taskCreateType: TaskCreateType = TaskCreateType.Campaign;
  campaignSource: CampaignSource = CampaignSource.Rules;
  getAccessTenantList$: Observable<any> = new Observable();
  tenantId = 0;
  btnLoading: boolean = false;
  emailActionPayload: EmailActionPayload | undefined; //= new BehaviorSubject<EmailActionPayload>({} as EmailActionPayload); 
  smsActionPayload: SmsActionPayload | undefined; // new BehaviorSubject<SmsActionPayload | null>({} as SmsActionPayload); 
  whatsAppActionPayload: WhatsappActionPayload | undefined;// = new BehaviorSubject<WhatsappActionPayload>({} as WhatsappActionPayload); 
  taskActionPayload: TaskActionPayload | undefined;  //= new BehaviorSubject<TaskActionPayload>({} as TaskActionPayload); 
  minDate: Date = new Date();
  maxDate: Date = new Date(new Date().setDate(new Date().getDate() + 30));
  pushNotificationsActionPayload: PushNotificationActionPayload | undefined;

  eventType= AutomationEventType[AutomationEventType.Campaign];
  campaignId: number = 0;
  sqlRule = new BehaviorSubject<string>("");
  showAmountSpenderPopup: boolean = false;
  selectedPrebuildCampaign:any;
  convertAmountKeysMapping = ["client_lifetimevalue_1"];
  campaignGroups: any[] = [];
  jsonRule: string = '';
  selectedCampaign: any;
  currencySymbol$ = new BehaviorSubject<string>('');
  
  // Client Filter properties
  clientFilterData: ClientFilterOutput = { filterType: 'none', clientIds: [] };
  clientFilterValid: boolean = true; // Start as true since default is "None"

  // Section collapse state
  showSegmentation = true;
  showActionsSection = true;

  // Blackout Configuration properties
  blackoutConfigs: BlackoutConfig[] = [];
  disabledDates: Date[] = [];

  // Time slot properties
  selectedTimeSlot = signal<string | null>(null);
  timeSlotOptions: { label: string; value: string }[] = [];
  communicationCategoryOptions: { label: string; value: number }[] = [];

  /** All 3-hour time slots across 24h */
  private readonly ALL_TIME_SLOTS: { label: string; value: string; startHour: number }[] = [
    { label: '12 AM – 3 AM',  value: '00:00', startHour: 0  },
    { label: '3 AM – 6 AM',   value: '03:00', startHour: 3  },
    { label: '6 AM – 9 AM',   value: '06:00', startHour: 6  },
    { label: '9 AM – 12 PM',  value: '09:00', startHour: 9  },
    { label: '12 PM – 3 PM',  value: '12:00', startHour: 12 },
    { label: '3 PM – 6 PM',   value: '15:00', startHour: 15 },
    { label: '6 PM – 9 PM',   value: '18:00', startHour: 18 },
    { label: '9 PM – 12 AM',  value: '21:00', startHour: 21 },
  ];


  constructor() {

      if (this.route.snapshot.paramMap.get('id')) {
        this.campaignId = parseInt(this.route.snapshot.paramMap.get('id') ?? '0');
      }

    this.actionsTableData = [
      { text: 'SEND_EMAIL', key: 'sendemail', icon: "fa fa-envelope font-light", color: "cyan-500", status: "Not Done", configured: false, action_data:{} as ScheduleActionPayload,action_payload:{} as any,description:"",formgroup:{} as any,notificationTo:SendNotificationTo.Client,schedule_event:"",schedule_in_min:0,uuid:"" },
      { text: 'SEND_SMS', key: 'sendsms', icon: "fa fa-comments", color: "pink-500", status: "Not Done", configured: false, action_data:{} as ScheduleActionPayload,action_payload:{} as any,description:"",formgroup:{} as any,notificationTo:SendNotificationTo.Client,schedule_event:"",schedule_in_min:0,uuid:"" },
      { text: 'CREATE_TASK', key: 'createtask', icon: "fa fa-phone", color: "orange-500", status: "Not Done", configured: false ,action_data:{} as ScheduleActionPayload,action_payload:{} as any,description:"",formgroup:{} as any,notificationTo:SendNotificationTo.Client,schedule_event:"",schedule_in_min:0,uuid:"" },
      { text: 'SEND_WHATSAPP', key: 'sendwhatsapp', icon: "fa fa-whatsapp", color: "green-500", status: "Not Done", configured: false ,action_data:{} as ScheduleActionPayload,action_payload:{} as any,description:"",formgroup:{} as any,notificationTo:SendNotificationTo.Client,schedule_event:"",schedule_in_min:0,uuid:"" },
      { text: 'SEND_PUSH_NOTIFICATION', key: 'sendpushnotifications', icon: "fa fa-bell", color: "purple-500", status: "Not Done", configured: false ,action_data:{} as ScheduleActionPayload,action_payload:{} as any,description:"",formgroup:{} as any,notificationTo:SendNotificationTo.Client,schedule_event:"",schedule_in_min:0,uuid:"" }
    ];


    this.createCampaignForm = this.fb.group({
      campaign_name: ['', [Validators.required]],
      campaign_action_date: [new Date(), Validators.required],
      campaign_description: ['', [Validators.required]],
      selected_tenant: ['', [Validators.required]],
      rule: ['', [Validators.required]],
      communication_category_id: [null, [Validators.required]],
    });

    this.amountSpenderForm = this.fb.group({
      amount: ['', [Validators.required]]
    });

    this.Actions.forEach((action) => {
      this.createCampaignForm.addControl(
        'selectedAction_' + action.key,
        new UntypedFormControl(false)
      );
    });

  }

  ngOnInit(): void {
    this.loadCommunicationCategories();
    //this.minDate = this.calculateTomorrowDate();
    this.minDate = new Date();
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      this.SelectedTenantsFormControl.setValue([this.tenantId]);
      this.tenantAccess = tenant.accessed_tenant;
      this.getTreeViewData();
      this.loadBlackoutConfigs();
    });

    this.store.select(COUNTRY_MASTER_STATE).subscribe((country) => {
      this.currencySymbol$.next(getCurrencySymbol(
        country.currency_code,
        'narrow',
        'en-US'
      ));
    });

    if (this.campaignId && this.campaignId > 0) {
      this.getCampaignData();
    }

    // Initialize campaign groups
    this.initializeCampaignGroups();

    // Initialize time slots based on default date (today)
    this.updateTimeSlots(new Date());
  }

  // Add new method to initialize campaign groups
  initializeCampaignGroups() {
    // Group campaigns by category
    const groupedCampaigns = CONSTANTS_PREBUILD_CAMPAIGNS.CAMPAIGNS.reduce((groups: any, campaign: any) => {
      const category = campaign.category;
      if (!groups[category]) {
        groups[category] = [];
      }
      groups[category].push({
        label: campaign.name,
        value: campaign.key,
        description: campaign.description,
        sql_rule: campaign.sql_rule,
        category: category  // Add category to each item for searching
      });
      return groups;
    } ,{});

    // Convert to PrimeNG dropdown format
    this.campaignGroups = Object.keys(groupedCampaigns).map(category => ({
      label: category,
      value: category.toLowerCase().replace(/\s+/g, '_'),
      items: groupedCampaigns[category]
    }));

    this.cd.detectChanges();
  }

  // Update campaign selection handler
  onCampaignSelect(event: any) {
    if (event.value) {
      // Find the selected campaign from the constants
      const selectedCampaign = CONSTANTS_PREBUILD_CAMPAIGNS.CAMPAIGNS.find(
        (campaign: any) => campaign.key === event.value
      );

      this.selectedPrebuildCampaign = selectedCampaign;

      if (selectedCampaign) {
        if (selectedCampaign.sql_rule) {
          const ruleObj = JSON.parse(selectedCampaign.sql_rule);
          const sqlQuery = ruleObj.sql;
          let params = ruleObj.params;

          // Special handling for BIRTHDAY_MONTH campaign
          if (selectedCampaign.key === 'BIRTHDAY_MONTH') {
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth(); // 0-11

            // Create start date (1st of current month)
            const startDate = new Date(year, month, 1);
            
            // Create end date (last day of current month)
            const endDate = new Date(year, month + 1, 0);

            // Format dates as YYYY-MM-DD
            const formatDate = (date: Date) => {
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');
              return `${year}-${month}-${day}`;
            };

            // Update the params with dynamic dates
            params = {
              ...params,
              client_dob_1: formatDate(startDate),
              client_dob_2: formatDate(endDate)
            };
          }

          if (selectedCampaign.key === 'HIGH_SPENDERS') {
            this.showAmountSpenderPopup = true;
            return;
          }

          // Create the JSON rule string
          this.jsonRule = JSON.stringify({
            sql: sqlQuery,
            params: params
          });

          const actualSqlQuery = sqlQuery.replace(/:(\w+)/g, (match: any, paramName: any) => {
            if (params[paramName] !== undefined) {
              // If the parameter value is a date string, format it properly
              const value = params[paramName];
              if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}$/)) {
                return `'${value}'`; // Wrap date strings in quotes
              }
              return params[paramName];
            }
            return match; // Return the placeholder unchanged if param not found
          });

          this.sqlRule.next(actualSqlQuery);
          this.RuleFormControl.setValue(this.jsonRule);
        }

        // Update campaign name and description if they're empty
        if (!this.CampaignNameFormControl.value) {
          this.CampaignNameFormControl.setValue(selectedCampaign.name);
        }
        if (!this.CampaignDescriptionFormControl.value) {
          this.CampaignDescriptionFormControl.setValue(selectedCampaign.description);
        }

        this.cd.detectChanges();
      }
    }
  }

  clearCampaign() {
    this.CampaignNameFormControl.setValue('');
    this.CampaignDescriptionFormControl.setValue('');
    this.RuleFormControl.setValue('');
    this.sqlRule.next('');
    this.jsonRule = '';
    this.cd.detectChanges();
  }

  getCampaignData() {
    this.campaignsService.GetCampaignById( this.tenantId, this.campaignId).subscribe((campaign) => {
      this.patchFormData(campaign);
    });
  }

  patchFormData(campaign: CampaignById) {
    this.createCampaignForm.patchValue({
      campaign_name: campaign.campaign_name,
      campaign_description: campaign.campaign_description,
      selected_tenant: [this.tenantId],
      communication_category_id:
        campaign.camp_actions?.[0]?.communication_category_id ??
        campaign.communication_category_id ??
        null,
    });
    this.configureExistingActions(campaign);
  }

  configureExistingActions(campaign: CampaignById) {
    if(!this.checkObjectEmpty(JSON.parse(campaign.camp_actions[0].source_data_extraction_rules)))
      {
        const ruleObj = JSON.parse(campaign.camp_actions[0].source_data_extraction_rules);
        const sqlQuery = ruleObj.rule.sql;
        const params = ruleObj.rule.params;
        const actualSqlQuery = sqlQuery.replace(/:(\w+)/g, (match:any, paramName:any) => {
            if (params[paramName] !== undefined) {
                return params[paramName];
            }
            return match; // Return the placeholder unchanged if param not found
        });
        this.sqlRule.next(actualSqlQuery);
        this.RuleFormControl.setValue(actualSqlQuery);
      }
      if(!this.checkObjectEmpty(JSON.parse(campaign.camp_actions[0].email_action_payload)))
        {
          this.actionsTableData.forEach(o => {
            if (o.key == 'sendemail') {
              o.status = "Done";
              o.configured = true;
              o.action_payload= JSON.parse(campaign.camp_actions[0].email_action_payload);
              o.schedule_in_min=  0
            }
          });
          this.emailActionPayload = JSON.parse(campaign.camp_actions[0].email_action_payload);
          this.createCampaignForm.get('selectedAction_sendemail')?.setValue(true);
        }
        if(!this.checkObjectEmpty(JSON.parse(campaign.camp_actions[0].sms_action_payload)))
        {
          this.actionsTableData.forEach(o => {
            if (o.key == 'sendsms') {
              o.status = "Done";
              o.configured = true;
              o.action_payload= JSON.parse(campaign.camp_actions[0].sms_action_payload);
              o.schedule_in_min=  0
            }
          });
          this.smsActionPayload = JSON.parse(campaign.camp_actions[0].sms_action_payload);
          this.createCampaignForm.get('selectedAction_sendsms')?.setValue(true);
        }
        if(!this.checkObjectEmpty(JSON.parse(campaign.camp_actions[0].whatsapp_action_payload)))
        {
          this.actionsTableData.forEach(o => {
            if (o.key == 'sendwhatsapp') {
              o.status = "Done";
              o.configured = true;
              o.action_payload= JSON.parse(campaign.camp_actions[0].whatsapp_action_payload);
              o.schedule_in_min=  0
            }
          });
          this.whatsAppActionPayload = JSON.parse(campaign.camp_actions[0].whatsapp_action_payload);
          this.createCampaignForm.get('selectedAction_sendwhatsapp')?.setValue(true);
        }
        if(!this.checkObjectEmpty(JSON.parse(campaign.camp_actions[0].task_action_payload)))
        {
          this.actionsTableData.forEach(o => {
            if (o.key == 'createtask') {
              o.status = "Done";
              o.configured = true;
              o.action_payload= JSON.parse(campaign.camp_actions[0].task_action_payload);
              o.schedule_in_min=  0
            }
          });
          this.taskActionPayload = JSON.parse(campaign.camp_actions[0].task_action_payload);
          this.createCampaignForm.get('selectedAction_createtask')?.setValue(true);
        }
     
        this.cd.detectChanges();
  }

  checkObjectEmpty(obj: any): boolean {
    for (const i in obj) return false;
    return true;
  }

  GetCountry(): void {
    this.store.select(COUNTRY_MASTER_STATE_LIST).subscribe((country) => {
      this.country$ = country;
    })
  }

  GetState(): void {
    this.store.select(STATE_MASTER_STATE_LIST).subscribe((state) => {
      this.state$ = state;
    })
  }

  GetCity(): void {
    this.store.select(CITY_MASTER_STATE_LIST).subscribe(city => {
      this.city$ = city;
    });
  }

  calculateTomorrowDate() {
    const today = new Date().setHours(0, 0, 0, 0);
    const tomorrowDate = new Date(today);
    return new Date(tomorrowDate.setDate(tomorrowDate.getDate() + 1));
  }

  // getStatesForCountryCodes(selectedCountryCodes: string[]): string[] {
  //   const filteredStates = this.state$
  //     .filter((state) => selectedCountryCodes.includes(state.country_code))
  //     .map((state) => state.code);

  //   return Array.from(new Set(filteredStates));
  // }

  getTreeViewData() {
    const allCountryCodes = this.tenantAccess.map((tenant) => tenant.country);
    const alltenantStateCodes = this.tenantAccess.map((tenant) => tenant.state);
    const distinctCountryCodes = allCountryCodes.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });
    const distinctStateCodes = alltenantStateCodes.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });

    const treeViewData = [];
    let i = 0;
    for (const state of distinctStateCodes) {
      const citiesInState = Array.from(new Set(
        this.tenantAccess
          .filter((tenant) => tenant.state === state)
          .map((tenant) => tenant.city)
      ));

      const stateNode = {
        key: i,
        label: state,
        icon: 'fa fa-globe',
        children: [] as any
      };
      let j = 0;
      for (const city of citiesInState) {
        const tenantsInCity = this.tenantAccess
          .filter((tenant) => tenant.state === state && tenant.city === city)
          .map((tenant) => ({
            label: tenant.name_primary_language,
            tenantid: tenant.id,
            selectable:tenant.status.toLowerCase() === 'inactive' ? false : true,
            styleClass: tenant.status.toLowerCase() === 'inactive' ? 'p-disabled' : '',
            children: []
          }));

        stateNode.children.push({
          key: j,
          label: city,
          icon: 'fa fa-globe',
          children: tenantsInCity
        });
        j++;
      }

      treeViewData.push(stateNode);
      i++;
    }
    this.tenants = treeViewData;
  }


  ToggleActions(event: any, action: string) {
    this.actionsTableData.forEach(o => {
      if (o.key == action) o.configured = event.checked;
    });
  }

  configureActions(action: string) {
    switch (action) {
      case "sendemail":
        {
          this.showBulkEmailPopup = true;
        }
        break;
      case "sendsms":
        {
          this.showBulkSmsPopup = true;
        }
        break;
      case "sendwhatsapp":
        {
          this.showBulkWhatsAppPopup = true;
        }
        break;
      case "createtask":
        {
          this.taskCreateType = TaskCreateType.Campaign;
          this.showTaskCreate = true;
        }
        break;
      case "createopportunity":
        {
          this.showCreateOpportunityPopup = true;
        }
        break;
      case "sendpushnotifications":
        {
          this.showPushNotificationsPopup = true;
          this.cd.detectChanges();
        }
        break;
    }
  }

  removeAction(action: string) {
    this.actionsTableData = this.actionsTableData.filter(o => o.key != action);
    this.actionsTableData.forEach(o => {
      if (o.key == action) o.configured = false;
    });
    this.createCampaignForm.get('selectedAction_' + action)?.setValue(false);
  }

  /**
   * Handle client filter changes from the ClientFilterComponent
   */
  onClientFilterChange(filterOutput: ClientFilterOutput): void {
    this.clientFilterData = filterOutput;
    this.cd.detectChanges();
  }

  /**
   * Handle client filter validity changes
   */
  onClientFilterValidityChange(isValid: boolean): void {
    this.clientFilterValid = isValid;
    this.cd.detectChanges();
  }

  /**
   * Build client filter object for payload.
   * Delegates to ClientFilterComponent.getFilterData() so that both
   * include_client_ids and exclude_client_ids are captured correctly,
   * even when both are filled in simultaneously.
   */
  private buildClientFilter(): ClientFilter | null {
    if (this.clientFilterComponent) {
      return this.clientFilterComponent.getFilterData();
    }

    // Fallback for single-type cases when ViewChild is unavailable
    if (this.clientFilterData.filterType === 'none' || this.clientFilterData.clientIds.length === 0) {
      return null;
    }

    const filter: ClientFilter = {};
    if (this.clientFilterData.filterType === 'include') {
      filter.include_client_ids = this.clientFilterData.clientIds;
    } else if (this.clientFilterData.filterType === 'exclude') {
      filter.exclude_client_ids = this.clientFilterData.clientIds;
    }
    return filter;
  }


  CreateCampaign() {
    if (this.createCampaignForm.valid && this.clientFilterValid) {
      if (!this.isActionSelected()) {
        this.translateService.get('CAMPAIGN.WARNING_MSG')
          .subscribe((translation) => {
            this.toastMessageService.showWarning(translation);
          });
        this.cd.detectChanges();
        return;
      }
      this.btnLoading = true;
      const selectedTenants = [this.tenantId] //this.SelectedTenantsFormControl.value as TreeNode[];
      const payloadRequest: CampaignRequest[] = [] as CampaignRequest[];
      const formValues = this.createCampaignForm.value;
     // let data = this.filterLastChildren(selectedTenants);

     selectedTenants.forEach((tenantId: any) => {
        const payload: CampaignRequest = {} as CampaignRequest;
        payload.tenant_id = tenantId;
        payload.campaign_name = formValues["campaign_name"];
        payload.campaign_isvisble = true;
        payload.campaign_description = formValues["campaign_description"];
        payload.actions_group = {} as CampaignActionsGroup;
        const actionGroups: CampaignActionsGroup = {} as CampaignActionsGroup;
        actionGroups.campaign_action_date = this.timeService.ConvertLocalDateTimeToUTC(
          this.buildScheduledDateTime(formValues["campaign_action_date"])
        );
        actionGroups.source_data_type = CampaignSource.Rules;
        const sourceDataExtractionRules: SourceDataExtractionRules = {} as SourceDataExtractionRules;
        const rule: Rule = {} as Rule;
        const params: Params = {} as Params;
        rule.params = params;
        const jsonString: string = formValues["rule"];
        if(jsonString && jsonString!= "")
        {
          const jsonObject = JSON.parse(jsonString);
          rule.params = this.convertAmountKeys(jsonObject.params);
          rule.sql = jsonObject.sql;
        }
        sourceDataExtractionRules.clients = null;
        sourceDataExtractionRules.reports = null;
        sourceDataExtractionRules.rule = Object.keys(rule.params).length > 0 ? rule : null;
        sourceDataExtractionRules.jsonrule = Object.keys(rule.params).length > 0 ? rule : null;
        
        // Add client filter to source data extraction rules
        sourceDataExtractionRules.client_filter = this.buildClientFilter();
        
        actionGroups.source_data_extraction_rules = sourceDataExtractionRules;
        actionGroups.action_payload =  [] as AutomationActionPayload[];
        const actionPayloads: AutomationActionPayload = {} as AutomationActionPayload;
        actionPayloads.actions = {} as AutomationActions;
        this.Actions.forEach(action => {
          actionPayloads.actions['webhook_action_payload'] = null;
          if (action.key == 'sendemail') {
            if (formValues["selectedAction_" + action.key]) {
              actionPayloads.actions['client_email_action_payload'] = this.emailActionPayload ? this.emailActionPayload : null;
            }
            else {
              actionPayloads.actions['client_email_action_payload'] = null;
            }
          }
          if (action.key == 'sendsms') {
            if (formValues["selectedAction_" + action.key]) {
              actionPayloads.actions['client_sms_action_payload'] = this.smsActionPayload ? this.smsActionPayload : null;
            }
            else {
              actionPayloads.actions['client_sms_action_payload'] = null;
            }
          }
          if (action.key == 'sendwhatsapp') {
            if (formValues["selectedAction_" + action.key]) {
              actionPayloads.actions['client_whatsapp_action_payload'] = this.whatsAppActionPayload ? this.whatsAppActionPayload : null;
            }
            else {
              actionPayloads.actions['client_whatsapp_action_payload']
            }
          }
          if (action.key == 'createtask') {
            if (formValues["selectedAction_" + action.key]) {
              actionPayloads.actions['staff_task_action_payload'] = this.taskActionPayload ? this.taskActionPayload : null;
              const notificationStaff:NotificationToStaff = {} as NotificationToStaff;
              notificationStaff.notify_record_associated_staff = true;
              notificationStaff.notify_additional_staff_to =[];
              actionPayloads.actions['notification_staff'] = notificationStaff;
            }
            else {
              actionPayloads.actions['staff_task_action_payload'] = null;
              const notificationStaff:NotificationToStaff = {} as NotificationToStaff;
              notificationStaff.notify_record_associated_staff = false;
              notificationStaff.notify_additional_staff_to =[];
              actionPayloads.actions['notification_staff'] = notificationStaff;
            }
          }
          if (action.key == 'sendpushnotifications') {
            if (formValues["selectedAction_" + action.key]) {
              actionPayloads.actions['client_pushnotification_action_payload'] = this.pushNotificationsActionPayload ? this.pushNotificationsActionPayload : null;
            }
            else {
              actionPayloads.actions['client_pushnotification_action_payload'] = null;
            }
          }
          
          actionPayloads.schedule_in_min = 0;
        }
        );
        
        actionGroups.action_payload.push(actionPayloads);
        actionGroups.communication_category_id = formValues['communication_category_id'];
        payload.actions_group = actionGroups;
        payload.campaign_ownership = OwnershipLevel.Tenant;
        payload.campaign_franchise = 0;
        payloadRequest.push(payload);

      });
      this.campaignsService.CreateCampaigns(payloadRequest).subscribe({
        next: () => {
          this.translateService.get('CAMPAIGN.MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.btnLoading = false;
          this.createCampaignForm.reset();
          this.cd.detectChanges();
          this.router.navigateByUrl('/campaign');
        },
        error: (error) => {
          this.toastMessageService.showError(error);
          this.btnLoading = false;
          this.cd.detectChanges();
        },
      });
    }
    else {
      Object.keys(this.createCampaignForm.controls).forEach((field) => {
        const control = this.createCampaignForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
      const firstElementWithError: Element | null = document.querySelector('.ng-invalid');
      if (firstElementWithError) firstElementWithError.scrollIntoView({ behavior: 'smooth' });
      this.btnLoading = false;
      this.cd.detectChanges();
    }
  }

  convertAmountKeys(params: any) {
    // Helper function to calculate similarity between two strings
    const calculateSimilarity = (str1: string, str2: string): number => {
      const longer = str1.length > str2.length ? str1 : str2;
      const shorter = str1.length > str2.length ? str2 : str1;
      
      if (longer.length === 0) {
        return 1.0;
      }

      // Convert both strings to lowercase for better matching
      const s1 = longer.toLowerCase();
      const s2 = shorter.toLowerCase();
      
      // Calculate the Levenshtein distance
      const costs: number[] = [];
      for (let i = 0; i <= s1.length; i++) {
        let lastValue = i;
        for (let j = 0; j <= s2.length; j++) {
          if (i === 0) {
            costs[j] = j;
          } else if (j > 0) {
            let newValue = costs[j - 1];
            if (s1.charAt(i - 1) !== s2.charAt(j - 1)) {
              newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
            }
            costs[j - 1] = lastValue;
            lastValue = newValue;
          }
        }
        if (i > 0) {
          costs[s2.length] = lastValue;
        }
      }
      
      // Calculate similarity as a ratio
      return (longer.length - costs[shorter.length]) / longer.length;
    };

    Object.keys(params).forEach((paramKey: string) => {
      // Check each key in convertAmountKeysMapping for similarity
      this.convertAmountKeysMapping.forEach((mappingKey: string) => {
        const similarity = calculateSimilarity(paramKey, mappingKey);
        
        // If similarity is greater than 80%
        if (similarity > 0.8 && params[paramKey]) {
          // Convert the amount
          params[paramKey] = this.commonService.ConvertMinorCurrencyFromAmount(params[paramKey]);
        }
      });
    });
    
    return params;
  }

  filterLastChildren(treeData: TreeNode[]): TreeNode[] {
    const lastChildren: TreeNode[] = [];

    function traverse(node: TreeNode) {
      if (node.children && node.children.length > 0) {
        // node.children.forEach((child) => {
        //   traverse(child);
        // });
      } else {
        lastChildren.push(node);
      }
    }

    treeData.forEach((node) => {
      traverse(node);
    });
    return lastChildren;
  }

  hideOpportunity(e: any) {
    this.showCreateOpportunityPopup = false;
  }

  HideTaskCreate(e: any) {
    this.showTaskCreate = false;
  }

  HideSendEmail(event: any) {
    this.showBulkEmailPopup = false;
    this.emailActionPayload = event.data;
    if (event.data) {
      this.actionsTableData.forEach(o => {
        if (o.key == 'sendemail') {
          o.status = "Done";
          o.configured = true;
          o.action_payload= event.data;
          o.schedule_in_min=  0
        }
      });
    }
  }

  HideSMSEmail(event: any) {
    this.showBulkSmsPopup = false;
    this.smsActionPayload = event.data;
    if (event.data) {
      this.actionsTableData.forEach(o => {
        if (o.key == 'sendsms') {
          o.status = "Done";
          o.configured = true;
          o.action_payload= event.data;
          o.schedule_in_min=  0
        }
      });
    }
  }

  HideWhatsAppPopup(event: any) {
    this.showBulkWhatsAppPopup = false;
    this.whatsAppActionPayload = event.data;
    if (event.data) {
      this.actionsTableData.forEach(o => {
        if (o.key == 'sendwhatsapp') {
          o.status = "Done";
          o.configured = true;
          o.action_payload= event.data;
          o.schedule_in_min=  0
        }
      });
    }
  }

  hideTaskCreate(event: any) {
    this.showTaskCreate = false;
    this.taskActionPayload = event.data;
    if (event.data) {
      this.actionsTableData.forEach(o => {
        if (o.key == 'createtask') {
          o.status = "Done";
          o.configured = true;
          o.action_payload= event.data;
          o.schedule_in_min=  0
        }
      });
    }
  }

  hidePushNotificationsPopup(event: any) {
    this.showPushNotificationsPopup = false;
    this.pushNotificationsActionPayload = event.data;
    if (event.data) {
      this.actionsTableData.forEach(o => {
        if (o.key == 'sendpushnotifications') {
          o.status = "Done";
          o.configured = true;
          o.action_payload= event.data;
          o.schedule_in_min=  0
        }
      });
    }
  }
  

  CancelCampaign() {
    this.createCampaignForm.reset();
    this.router.navigateByUrl('/campaign');
  }

  isActionSelected() {
    return this.actionsTableData.filter(o => o.configured && o.status == 'Done').length > 0;
  }

  getRule(event: any): void {
    this.RuleFormControl.setValue(event.rule);
  }

  closeDialogEvent() {
    this.showAmountSpenderPopup = false;
    this.clearCampaign();
    this.cd.detectChanges();
  }

  addAmountSpender() {
    if(this.amountSpenderForm.valid)
    {
    const ruleObj = JSON.parse(this.selectedPrebuildCampaign.sql_rule);
    const sqlQuery = ruleObj.sql;
    const params = ruleObj.params;  

    params['client_lifetimevalue_1'] = this.AmountSpenderFormControl.value;
    const actualSqlQuery = sqlQuery.replace(/:(\w+)/g, (match:any, paramName:any) => {
      if (params[paramName] !== undefined) {
        return params[paramName];
      }
    });
    this.sqlRule.next(actualSqlQuery);
    this.RuleFormControl.setValue(actualSqlQuery);
    // Update campaign name and description if they're empty
    if (!this.CampaignNameFormControl.value) {
      this.CampaignNameFormControl.setValue(this.selectedPrebuildCampaign.name);
    }
    if (!this.CampaignDescriptionFormControl.value) {
      this.CampaignDescriptionFormControl.setValue(this.selectedPrebuildCampaign.description);
    }
    this.amountSpenderForm.reset();
    this.showAmountSpenderPopup = false;
    this.cd.detectChanges();
    }
    else
    {
      this.amountSpenderForm.markAllAsTouched();
      this.cd.detectChanges();
    }
  }

  get getEmailActipnPayload() {
    return new BehaviorSubject<EmailActionPayload>(this.emailActionPayload!)
  }

  get getSmsActipnPayload() {
    return new BehaviorSubject<SmsActionPayload>(this.smsActionPayload!)
  }

  get getWhatsappActipnPayload() {
    return new BehaviorSubject<WhatsappActionPayload>(this.whatsAppActionPayload!)
  }

  get getTaskActipnPayload() {
    return new BehaviorSubject<TaskActionPayload>(this.taskActionPayload!)
  }

  get getPushNotificationsActipnPayload() {
    return new BehaviorSubject<PushNotificationActionPayload>(this.pushNotificationsActionPayload!)
  }

  get ActionTableData() {
    return this.actionsTableData.filter(o => o.configured);
  }

  get CampaignNameFormControl(): UntypedFormControl {
    return this.createCampaignForm.controls['campaign_name'] as UntypedFormControl;
  }

  get CampaignDescriptionFormControl(): UntypedFormControl {
    return this.createCampaignForm.controls['campaign_description'] as UntypedFormControl;
  }

  get CampaignActionDateFormControl(): UntypedFormControl {
    return this.createCampaignForm.controls['campaign_action_date'] as UntypedFormControl;
  }

  get SelectedActionsFormControl(): UntypedFormControl {
    return this.createCampaignForm.controls['selected_actions'] as UntypedFormControl;
  }

  get SelectedTenantsFormControl(): UntypedFormControl {
    return this.createCampaignForm.controls['selected_tenant'] as UntypedFormControl;
  }

  get RuleFormControl(): UntypedFormControl {
    return this.createCampaignForm.controls['rule'] as UntypedFormControl;
  }

  get CommunicationCategoryFormControl(): UntypedFormControl {
    return this.createCampaignForm.controls['communication_category_id'] as UntypedFormControl;
  }

  private loadCommunicationCategories(): void {
    this.communicationCategoryService.listCategories().subscribe({
      next: (categories) => {
        this.communicationCategoryOptions = categories
          .filter((category) => isCommunicationCategoryActive(category.status))
          .map((category) => ({ label: category.name, value: category.id }));
        this.cd.detectChanges();
      },
    });
  }

  get AmountSpenderFormControl(): UntypedFormControl {
    return this.amountSpenderForm.controls['amount'] as UntypedFormControl;
  }

  /**
   * Called when the campaign date picker value changes.
   * Rebuilds the time slot options — if today is selected, only future slots are shown.
   */
  onDateChange(date: Date | null): void {
    this.selectedTimeSlot.set(null);
    this.updateTimeSlots(date);
    this.cd.detectChanges();
  }

  updateTimeSlots(date: Date | null): void {
    if (!date) {
      this.timeSlotOptions = [...this.ALL_TIME_SLOTS];
      return;
    }
    const now = new Date();
    const isToday =
      date.getFullYear() === now.getFullYear() &&
      date.getMonth() === now.getMonth() &&
      date.getDate() === now.getDate();

    if (isToday) {
      // Convert current time to fractional hours (e.g. 12:51 → 12.85)
      const currentFractionalHour = now.getHours() + now.getMinutes() / 60;
      // Show slots whose window END (startHour + 3) is still in the future
      // e.g. at 12:51 → 12:00–15:00 slot end = 15.0 > 12.85 → show ✓
      //                  09:00–12:00 slot end = 12.0 > 12.85 → false → hide ✓
      this.timeSlotOptions = this.ALL_TIME_SLOTS.filter(
        (slot) => slot.startHour + 3 > currentFractionalHour
      );
    } else {
      this.timeSlotOptions = [...this.ALL_TIME_SLOTS];
    }
  }

  /**
   * Combines the selected date with the selected time slot start time.
   * If no time slot is selected, the date is returned as-is (midnight local).
   * e.g. date = 2026-03-24, slot = '15:00'  →  2026-03-24T15:00:00 local
   */
  private buildScheduledDateTime(date: Date): Date {
    const result = new Date(date);
    const slot = this.selectedTimeSlot();
    if (slot) {
      const [hours, minutes] = slot.split(':').map(Number);
      result.setHours(hours ?? 0, minutes ?? 0, 0, 0);
    } else {
      result.setHours(0, 0, 0, 0);
    }
    return result;
  }

  /**
   * Load active blackout configurations and calculate disabled dates for the calendar.
   * Only Date-type blackout periods are used to disable dates.
   */
  loadBlackoutConfigs(): void {
    if (!this.tenantId) return;

    this.blackoutService.getActiveBlackoutConfigs(this.tenantId).subscribe({
      next: (response) => {
        let configs: BlackoutConfig[] = [];
        if (Array.isArray(response)) {
          configs = response;
        } else if (response?.data) {
          configs = response.data;
        }
        this.blackoutConfigs = configs;
        this.calculateDisabledDates();
        this.cd.markForCheck();
      },
      error: () => { /* silently ignore — calendar will just have no disabled dates */ }
    });
  }

  /**
   * Calculate which dates should be disabled based on Date-type blackout configs.
   * Builds the full array first, then assigns it as a new reference so OnPush
   * bindings on the datepicker detect the change.
   */
  calculateDisabledDates(): void {
    const result: Date[] = [];
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const oneYearFromNow = new Date(today);
    oneYearFromNow.setFullYear(today.getFullYear() + 1);

    this.blackoutConfigs.forEach((config) => {
      if (config.type !== 'Date' || !config.start_date || !config.end_date) return;

      // Parse UTC strings to local date components
      const parseLocalDate = (utcStr: string): Date => {
        const d = new Date(utcStr.includes('Z') ? utcStr : utcStr + 'Z');
        return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
      };

      const startDate = parseLocalDate(config.start_date);
      const endDate = parseLocalDate(config.end_date);

      if (config.is_recurring) {
        this.addRecurringBlackoutDates(result, startDate, endDate, today, oneYearFromNow);
      } else if (endDate >= today) {
        this.addDateRangeToDisabled(result, startDate, endDate);
      }
    });

    // Assign new array reference — required for OnPush datepicker to detect the change
    this.disabledDates = result;
  }

  /**
   * Add recurring blackout dates for the current and next year.
   */
  private addRecurringBlackoutDates(
    disabledDates: Date[],
    configStart: Date,
    configEnd: Date,
    rangeStart: Date,
    rangeEnd: Date
  ): void {
    const startMonth = configStart.getMonth();
    const startDay = configStart.getDate();
    const endMonth = configEnd.getMonth();
    const endDay = configEnd.getDate();

    [rangeStart.getFullYear(), rangeStart.getFullYear() + 1].forEach((year) => {
      const yearStart = new Date(year, startMonth, startDay, 0, 0, 0, 0);
      const yearEnd = new Date(year, endMonth, endDay, 0, 0, 0, 0);
      if (yearEnd >= rangeStart && yearStart <= rangeEnd) {
        this.addDateRangeToDisabled(disabledDates, yearStart, yearEnd);
      }
    });
  }

  /**
   * Add all dates in a range to the disabled dates array.
   */
  private addDateRangeToDisabled(disabledDates: Date[], startDate: Date, endDate: Date): void {
    const current = new Date(startDate);
    current.setHours(0, 0, 0, 0);
    const end = new Date(endDate);
    end.setHours(0, 0, 0, 0);
    while (current <= end) {
      disabledDates.push(new Date(current));
      current.setDate(current.getDate() + 1);
    }
  }

}

